import { render, staticRenderFns } from "./KaaroAlphaWidget.vue?vue&type=template&id=05d992db"
import script from "./KaaroAlphaWidget.vue?vue&type=script&lang=js"
export * from "./KaaroAlphaWidget.vue?vue&type=script&lang=js"
import style0 from "./KaaroAlphaWidget.vue?vue&type=style&index=0&id=05d992db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports